
import styles from '../styles/PokemonItem.module.css'; 
import stylesPeriod from '../styles/Period.module.css';
import UserPokemonList from '../components/Pokemon/UserPokemonList';


const Classnames = ({pokemon, period}) => { // Bien passer les props en ({}) et pas juste entre (), c'est pour ça que ça buguait

    const detailsClassName = `${styles.pokemonDetails}`;
    const checkedClassName = UserPokemonList.checked ? styles.checked : '';
    const nightClassName = stylesPeriod._day;
    const sizeClassName = pokemon.size === 'Petit' ? styles.petit : pokemon.size === 'Grand' ? styles.grand : '';

    return {
        detailsClassName,
        checkedClassName,
        nightClassName,
        sizeClassName
    }
}

export default Classnames;
